import React from "react";
import { situations } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function ForYouSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-109" data-mp="nsfr22ad8yq0">
      <div className="mx-auto max-w-5xl" data-id="element-110" data-mp="nq393p4lyocy">
        <SectionHeading eyebrow="Is This For You?" title="Do Any of These Situations Sound Familiar?" subtitle="If you recognize even one of these situations, I created Endo Blueprint™ with you in mind." data-id="element-111" data-mp="istdfrqmlggo" />
        <ol className="mt-10 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-112" data-mp="3mbmlxq4jrf3z">
          {situations.map((s, i) => <li key={s.title} className="flex gap-4 border-t border-line pt-6" data-id="element-113" data-mp="4vehs59s4cg9" data-mpi={i}>
              <span className="font-display text-4xl font-extrabold leading-none text-cyan" data-id="element-114" data-mp="1acrrk2qeht">{i + 1}</span>
              <div data-id="element-115" data-mp="38gkdav8bfbnh">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-116" data-mp="38g28vbbi1r4h">{s.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-117" data-mp="33h7o43tz1shq">{s.text}</p>
              </div>
            </li>)}
        </ol>
        <div className="mx-auto mt-12 max-w-3xl rounded-2xl bg-navy p-6 text-center sm:p-8" data-id="element-118" data-mp="fomr90e0zfad">
          <p className="text-lg font-semibold text-white" data-id="element-119" data-mp="kfmpc8yvs3eg">And that's exactly why I built Endo Blueprint™.</p>
          <p className="mt-3 font-display text-xl font-bold italic leading-snug text-cyan sm:text-2xl" data-id="element-120" data-mp="ohzuav5szxa6">
            The problem isn't always a lack of information. Sometimes, it's the lack of a clear structure for organizing
            the information you already have.
          </p>
        </div>
        <TransformCta label="Get My Endo Blueprint™" data-id="element-121" data-mp="rvxp7r18xso" />
      </div>
    </section>;
}